/**
 * OrdenaSuite - Bootstrap de JavaScript
 *
 * Configura axios y otras librerias globales.
 */

import axios from 'axios';

// Configurar axios globalmente
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;
window.axios.defaults.withXSRFToken = true;

// Tipos globales
declare global {
    interface Window {
        axios: typeof axios;
    }
}
